export default "__VITE_ASSET__386de374__"